/* tslint:disable */
/* eslint-disable */
/**
 * UPM-metsa-api
 * UPM Metsä API specification
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LocalizedValue
 */
export interface LocalizedValue {
    /**
     * 
     * @type {string}
     * @memberof LocalizedValue
     */
    language: string;
    /**
     * 
     * @type {string}
     * @memberof LocalizedValue
     */
    value: string;
}

export function LocalizedValueFromJSON(json: any): LocalizedValue {
    return LocalizedValueFromJSONTyped(json, false);
}

export function LocalizedValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): LocalizedValue {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'language': json['language'],
        'value': json['value'],
    };
}

export function LocalizedValueToJSON(value?: LocalizedValue | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'language': value.language,
        'value': value.value,
    };
}


